module.exports = __webpack_public_path__ + "static/media/birthday-post-banner.95db9c60.svg";